import { useWhaleRetentionCTA } from "@/components/dialogs/WhaleRetentionDialog/useWhaleRetentionCTA";

import { Fragment } from "react/jsx-runtime";

export const DialogTriggers = () => {
    useWhaleRetentionCTA();

    return <Fragment />;
};
